import { render, staticRenderFns } from "./G-2__SupportCategoryCreate.vue?vue&type=template&id=ec9c9a5c&"
import script from "./G-2__SupportCategoryCreate.vue?vue&type=script&lang=js&"
export * from "./G-2__SupportCategoryCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VForm,VSpacer})
